/**
 * src/components/IconButtons.tsx
 * Shared icon action buttons used in entity lists (reports, clients, sites).
 */

// ── Eye / Open ─────────────────────────────────────────────────────────────────
export function BtnOpen({ onClick, title="Ouvrir", disabled }: { onClick:()=>void; title?:string; disabled?:boolean }) {
  return (
    <button onClick={onClick} title={title} disabled={disabled}
      style={{ background:"none", border:"1.5px solid #d0e8d0", borderRadius:8,
        width:36, height:36, cursor:disabled?"not-allowed":"pointer", opacity:disabled?0.5:1,
        display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
      <svg width="18" height="13" viewBox="0 0 18 13" fill="none">
        <path d="M9 1C5 1 1.73 3.89 1 6.5c.73 2.61 4 5.5 8 5.5s7.27-2.89 8-5.5C16.27 3.89 13 1 9 1z"
          stroke="var(--green-dim)" strokeWidth="1.5" fill="none"/>
        <circle cx="9" cy="6.5" r="2.3" stroke="var(--green-dim)" strokeWidth="1.5" fill="none"/>
        <circle cx="9" cy="6.5" r="0.8" fill="var(--green-dim)"/>
      </svg>
    </button>
  );
}

// ── Pencil / Edit ──────────────────────────────────────────────────────────────
export function BtnEdit({ onClick, title="Modifier" }: { onClick:()=>void; title?:string }) {
  return (
    <button onClick={onClick} title={title}
      style={{ background:"none", border:"1.5px solid #e0e0e0", borderRadius:8,
        width:36, height:36, cursor:"pointer",
        display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path d="M10.5 1.5a1.5 1.5 0 0 1 2.12 0l.88.88a1.5 1.5 0 0 1 0 2.12L5 13H2v-3L10.5 1.5z"
          stroke="var(--text-secondary)" strokeWidth="1.4" strokeLinejoin="round" fill="none"/>
        <line x1="8.5" y1="3.5" x2="11.5" y2="6.5" stroke="var(--text-secondary)" strokeWidth="1.3"/>
      </svg>
    </button>
  );
}

// ── Warning badge — small "!" circle overlaid on a button's corner ─────────────
export function WarningBadge({ title }: { title: string }) {
  return (
    <div title={title}
      style={{ position:"absolute", top:-4, right:-4, zIndex:1, width:16, height:16, borderRadius:"50%",
        background:"#e8a838", border:"2px solid #fff", display:"flex", alignItems:"center", justifyContent:"center",
        fontSize:10, color:"#fff", fontWeight:800, cursor:"help", boxShadow:"0 1px 4px rgba(0,0,0,0.3)" }}>
      !
    </div>
  );
}

// ── Trash / Delete ─────────────────────────────────────────────────────────────
export function BtnDelete({ onClick, title="Supprimer", disabled }: { onClick:()=>void; title?:string; disabled?:boolean }) {
  return (
    <button onClick={onClick} title={title} disabled={disabled}
      style={{ background:"none", border:"1.5px solid #f0e0e0", borderRadius:8,
        width:36, height:36, cursor:disabled?"not-allowed":"pointer", opacity:disabled?0.5:1,
        display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
        <path d="M1 3.5h12M5 3.5V2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5M2.5 3.5l.75 9.5a1 1 0 0 0 1 .95h5.5a1 1 0 0 0 1-.95l.75-9.5"
          stroke="var(--red)" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        <line x1="5.5" y1="7" x2="5.5" y2="11.5" stroke="var(--red)" strokeWidth="1.3" strokeLinecap="round"/>
        <line x1="8.5" y1="7" x2="8.5" y2="11.5" stroke="var(--red)" strokeWidth="1.3" strokeLinecap="round"/>
      </svg>
    </button>
  );
}
